<template>
  <div style="display:flex;background-color: rgb(102,255,102)">
    <div class="p-1 border border-right-0 border-bottom-0 border-dark column50">
      {{ title }}
    </div>
    <div class="p-1 text-center border border-bottom-0 border-dark column50">
      PENJELASAN
    </div>
  </div>
</template>
<script>
export default {
  props: ['title'],
}
</script>
